import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IMessage } from '@bciti/types';

@Component({
    selector: 'app-message-detail-dialog',
    templateUrl: './message-detail-dialog.component.html',
    styleUrls: ['./message-detail-dialog.component.scss'],
})
export class MessageDetailDialogComponent {
    JSON = JSON;
    constructor(@Inject(MAT_DIALOG_DATA) public data: IMessage) {}
}
